import { CourseAddOn, OccurrenceAddOn, SelectedAddOns } from '@shared/types';
import { FunctionComponent } from 'react';
import { AddOnsSelect } from '../AddonsSelect';

export type AddonsSectionProps = {
    addons: Array<CourseAddOn | OccurrenceAddOn>;
    selectedAddOns: SelectedAddOns;
    hidePricing?: boolean;
    setSelectedAddOns: (selectedAddOns: SelectedAddOns) => unknown;
    currency: string;
};

export const AddonsSection: FunctionComponent<AddonsSectionProps> = ({
    addons,
    selectedAddOns,
    hidePricing,
    setSelectedAddOns,
    currency,
}) => {
    if (addons.length === 0) {
        return null;
    }

    return (
        <>
            <h3>Add-ons</h3>
            <AddOnsSelect
                addOns={addons}
                selectedAddOns={selectedAddOns}
                hidePricing={hidePricing}
                setSelectedAddOns={setSelectedAddOns}
                currency={currency}
            />
        </>
    );
};
